import { render, staticRenderFns } from "./ag.vue?vue&type=template&id=3b4957be&scoped=true"
import script from "./ag.vue?vue&type=script&lang=js"
export * from "./ag.vue?vue&type=script&lang=js"
import style0 from "./ag.vue?vue&type=style&index=0&id=3b4957be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4957be",
  null
  
)

export default component.exports